<template>
	<div class="container">
		<div class="card-panel">
			<h5 class="header">Adauga echipa</h5>
			<form v-on:submit="addEchipa">
				<div class="row">
					<div class="col s4">
						<h6>Persoane echipa</h6>
						<div class="input-field">
							<input
								id="pers"
								type="text"
								class="validate"
								v-model="new_pers"
							/>
							<label for="pers">Adauga persoana</label>
							<span
								><button class="btn" @click.prevent="addPers">+</button></span
							>
						</div>
						<ul class="">
							<li v-for="(item, index) in persoane" :key="index">
								{{ item
								}}<span class="delete" @click.prevent="deletePers(index)"
									>X</span
								>
							</li>
						</ul>
					</div>
					<div class="col s4">
						<div class="input-field">
							<select v-model="utilaj">
								<option value="" disabled selected>Selecteaza utilaj</option>
								<option value="Elumatec">Elumatec</option>
								<option value="Graule">Graule</option>
							</select>
							<label>Utilaj</label>
						</div>
					</div>
				</div>
				<br />
				<button type="submit" class="btn">Salveaza</button>
				<router-link class="btn blue-grey lighten-2" to="/debitare/echipe"
					>Anuleaza</router-link
				>
			</form>
			<!-- <pre>{{$data}}</pre> -->
		</div>
	</div>
</template>

<script>
export default {
	name: "AddEchipa",
	data() {
		return {
			persoane: [],
			utilaj: "",
			new_pers: "",
		};
	},
	methods: {
		addPers() {
			if (this.new_pers !== "") {
				this.persoane.push(this.new_pers);
				this.new_pers = "";
			}
		},
		deletePers(i) {
			this.persoane.splice(i, 1);
		},
		addEchipa(e) {
			if (!this.persoane) {
				M.toast({ html: "Completati persoanele!" });
			} else {
				let newEchipa = {
					echipa_utilaj: this.utilaj,
					echipa_nume: JSON.stringify(this.persoane),
				};

				this.$http
					.post(
						"http://hub.cuprolli.ro/app_back/index.php/api/debitare/echipe/add",
						newEchipa
					)
					.then(function() {
						this.$router.push({
							path: "/debitare/echipe",
							query: M.toast({ html: "Echipa adaugata!" }),
						});
					});

				e.preventDefault();
			}
			e.preventDefault();
		},
	},
	mounted: function() {
		var m4 = document.querySelectorAll("select");
		M.FormSelect.init(m4);
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#pers {
	width: 60%;
}
li span.delete {
	cursor: pointer;
	margin-left: 10px;
	color: #e65100;
}
</style>
